export const FunctionMap = [
  { Name: "parse", Scope: ["String"] },
  { Name: "getProperty", Scope: ["String", "PropertyName"] },
  { Name: "map", Scope: ["Array", "PropertyName"] },
  { Name: "join", Scope: ["Array"] },
  { Name: "getEmailsFromPeoplePickerInTable", Scope: ["Table", "ColumnName", "Filter"] },
  { Name: "getEmailsFromPeoplePicker", Scope: ["PeoplePicker"] },
].sort((a, b) => a.Name.localeCompare(b.Name));
